<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M484.9 72.9v366.2c0 12.6-13.3 22.9-29.9 22.9H335.7v-62.6h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5s6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1-4.2-3.2-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6v-41h72.6c5.9 0 11.6-1.8 15.7-5 4.2-3.2 6.5-7.5 6.5-12.1v-6.8c0-4.5-2.3-8.9-6.5-12.1s-9.8-5-15.7-5h-72.6V50H455c16.5 0 29.9 10.2 29.9 22.9z" fill="#e6e6e6" />
      <path d="M44.2 47.2 294.7 6.1c2.9-.5 5.7.5 7.9 2.7s3.4 5.3 3.4 8.6v477.1c0 3.3-1.2 6.5-3.4 8.6-2.2 2.2-5 3.2-7.9 2.7l-250.4-41c-9.8-1.6-17.1-11.3-17.1-22.7V69.9c-.1-11.4 7.2-21.1 17-22.7z" fill="#ff4867" />
      <path d="M141.6 210.2z" fill="#f05264" />
      <path d="M430.6 375.5v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.5 6.5 12.1zm0-82v6.8c0 4.5-2.3 8.9-6.5 12.1s-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5 4.1 3.3 6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1zm0-81.9v6.8c0 4.5-2.3 8.9-6.5 12.1-4.2 3.2-9.8 5-15.7 5h-72.6v-41h72.6c5.9 0 11.6 1.8 15.7 5s6.5 7.6 6.5 12.1z" fill="#b8b8b8" />
      <path d="M260.7 371c-23.1 0-43.8-39.7-54.7-65.4-18.3-7.7-38.6-14.8-58.2-19.4-17.2 11.3-46.4 28.3-68.9 28.3-13.9 0-24-7-27.7-19.2-2.8-10-.4-17 2.6-20.7 5.9-8.1 18.1-12.2 36.4-12.2 14.8 0 33.6 2.6 54.5 7.7 13.5-9.6 27.2-20.7 39.4-32.5-5.4-25.7-11.3-67.4 3.7-86.6 7.4-9.2 18.8-12.2 32.5-8.1 15 4.3 20.7 13.5 22.5 20.7 6.4 25.1-22.5 58.9-41.9 78.7 4.3 17.2 10 35.3 17 51.9 27.9 12.4 61 31 64.8 51.2 1.5 7-.7 13.5-6.4 19.2-4.9 4-10.1 6.4-15.6 6.4zm-20.8-43.7c5.1 11.3 9.9 16.7 12.5 16.7.4 0 .9-.2 1.7-.9.9-1 .9-1.7.8-2.4-.5-3-4.8-7.9-15-13.4zM93.2 281.5c-8.1 0-10.4 2-11 2.9-.2.3-.8 1.2-.2 3.5.5 2 1.8 4.1 6.1 4.1 5.3 0 12.9-3 21.8-8.3-6.4-1.6-12-2.2-16.7-2.2zm79.6-10.2c4.9 1.4 9.9 3.1 14.6 4.9-1.7-4.5-3.1-9.1-4.2-13.5-3.4 3-6.9 5.8-10.4 8.6zm34.3-97.6c-1.7 0-2.9.6-4 1.8-3.2 4.1-3.6 14.3-1.1 27.3 9.4-10.1 14.6-19.4 13.3-24.4-.2-.7-.7-3-5.1-4.2-1.2-.3-2.2-.5-3.1-.5zm0 0" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
